<template>
  <v-container fluid>
    <v-layout row justify-space-around>
      <v-flex xs8>
        <v-layout column justify-space-around>
          <div style="margin:0 auto;">
            <v-img contain height=100 width=150 :src="require('../../images/vss_employee_logo.png')"></v-img>
          </div>
          <form>
            <v-text-field
              v-model="email"
              label="Email"
            ></v-text-field>
            <v-flex align-self-end>
              <v-btn type="submit" class="no-margin-button" color="success" @click.prevent="submitPasswordReset">
                <v-icon left>forward</v-icon>
                Send Password Reset
              </v-btn>
              <router-link :to="{ name: 'login' }">Back to Log in</router-link>
            </v-flex>
          </form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      email: '',
    }
  },
  methods: {
    submitPasswordReset() {
      this.$store.dispatch('userAuth/requestPasswordReset', this.email)
        .then(() => {
          this.$store.dispatch('global/showSnackbarSuccess', { message: 'A password reset email has been sent!' })
          this.$router.push("/login")
        })
        .catch(err => {
          this.$store.dispatch('global/showSnackbarError', { message: "That email wasn't found..." })
        })
        .finally(res => {
          this.email = ''
          // this.$router.push("/login")
        })
    },
    fetchData () {
    },
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
